import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import { StyledButton } from "../../../components/common/Button";

const faqData = [
  {
    panel: "panel1",
    question:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.",
  },
  {
    panel: "panel2",
    question:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.",
  },
  {
    panel: "panel3",
    question:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.",
  },
];

const FAQs = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box>
        <Box sx={{ backgroundColor: "#EEF6FF" }}>
          <Container>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  marginTop: ["3.75rem", "6.875rem"],
                  fontSize: ["1.375rem", "3rem"],
                  fontWeight: 700,
                  textAlign: "center",
                  color: "#212121",
                }}
              >
                Frequently Asked Questions
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: ["2.5rem", "3.875rem"],
                paddingBottom: ["3.75rem", "7.5rem"],
              }}
            >
              {faqData.map((item, index) => (
                <Accordion
                  key={index}
                  expanded={expanded === item.panel}
                  onChange={handleChange(item.panel)}
                  sx={{ backgroundColor: "#EEF6FF" }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMore
                        sx={{ color: `${theme.palette.primary.main}` }}
                      />
                    }
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: ["0.5rem", "2rem"],
                        fontSize: ["0.75rem", "1.25rem"],
                        fontWeight: 700,
                        letterSpacing: ["0.0079055rem", "0.01rem"],
                        color: "#212121",
                      }}
                    >
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: ["1.25rem", "2rem"],
                        fontSize: ["0.75rem", "1.25rem"],
                        fontWeight: 400,
                        letterSpacing: ["0.0079055rem", "0.01rem"],
                        color: "#212121",
                      }}
                    >
                      {item.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Container>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                marginTop: ["3.75rem", "7.5rem"],
                fontSize: ["1.375rem", "3rem"],
                fontWeight: 700,
                color: "#212121",
                textAlign: "center",
              }}
            >
              Create a new account
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                marginTop: ["0.5rem", "2rem"],
                fontSize: ["0.75rem", "1.25rem"],
                fontWeight: 400,
                letterSpacing: ["0.0079055rem", "0.01rem"],
                color: "#212121",
                textAlign: "center",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {isMobile ? (
              <StyledButton
                variant="contained"
                height="1.5rem"
                width="10.375rem"
                style={{
                  marginTop: "1.25rem",
                  marginBottom: "3.75rem",
                  backgroundColor: `${theme.palette.primary.main}`,
                  borderRadius: "1.022175rem",
                }}
              >
                <Typography sx={{ fontSize: "0.5rem" }}>SIGN UP NOW</Typography>
              </StyledButton>
            ) : (
              <StyledButton
                variant="contained"
                height="3rem"
                width="11.6875rem"
                style={{
                  marginTop: "3.75rem",
                  marginBottom: "7.5rem",
                  backgroundColor: `${theme.palette.primary.main}`,
                }}
              >
                SIGN UP NOW
              </StyledButton>
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default FAQs;
